import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { CONTACT_EMAIL_PATTERN } from "src/libs/portal/season/contact-policy";
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type AuthMode = 'login' | 'signup';

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  --brand-950: #0b2f22;
  --brand-900: #0d3a29;
  --brand-800: #115537;
  --brand-700: #19723f;
  --brand-600: #248b4b;
  --brand-100: #dcf3e3;
  --brand-50: #f0faf3;
  --market-700: #08788a;
  --market-100: #d8f2f5;
  --ink-950: #0b1410;
  --ink-700: #35443c;
  --ink-500: #68766e;
  --line: #dce5df;
  display: block;
  min-height: 100%;
  color: var(--ink-950);
}

.auth-shell,
.auth-shell * {
  box-sizing: border-box;
}

.auth-shell button,
.auth-shell input {
  font: inherit;
}

.auth-shell button {
  -webkit-tap-highlight-color: transparent;
}

.auth-shell {
  position: relative;
  isolation: isolate;
  display: flex;
  min-height: 100dvh;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 24px;
  background: radial-gradient(circle at 8% 4%, rgba(30, 145, 78, 0.11), transparent 30%), radial-gradient(circle at 92% 96%, rgba(8, 120, 138, 0.09), transparent 28%), #f3f7f4;
}

.auth-ambient {
  position: absolute;
  z-index: -1;
  border-radius: 999px;
  filter: blur(1px);
  pointer-events: none;
}

.auth-ambient--one {
  top: -180px;
  left: -140px;
  width: 420px;
  height: 420px;
  border: 1px solid rgba(25, 114, 63, 0.13);
  box-shadow: 0 0 0 52px rgba(25, 114, 63, 0.025), 0 0 0 104px rgba(25, 114, 63, 0.018);
}

.auth-ambient--two {
  right: -110px;
  bottom: -190px;
  width: 380px;
  height: 380px;
  border: 1px solid rgba(8, 120, 138, 0.12);
  box-shadow: 0 0 0 44px rgba(8, 120, 138, 0.023), 0 0 0 88px rgba(8, 120, 138, 0.016);
}

.auth-frame {
  position: relative;
  z-index: 1;
  display: grid;
  width: min(1320px, 100%);
  min-height: min(820px, 100dvh - 48px);
  grid-template-columns: minmax(0, 1.08fr) minmax(500px, 0.92fr);
  overflow: hidden;
  border: 1px solid rgba(17, 85, 55, 0.11);
  border-radius: 30px;
  background: #ffffff;
  box-shadow: 0 34px 90px rgba(11, 47, 34, 0.13), 0 8px 28px rgba(11, 47, 34, 0.07);
}

.auth-story {
  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  padding: 48px 52px 42px;
  color: #ffffff;
  background: radial-gradient(circle at 84% 18%, rgba(89, 211, 132, 0.22), transparent 28%), radial-gradient(circle at 12% 92%, rgba(40, 166, 180, 0.17), transparent 30%), linear-gradient(145deg, #0a2f22 0%, #0d452e 48%, #12603b 100%);
}

.story-pattern {
  position: absolute;
  inset: 0;
  opacity: 0.25;
  background-image: radial-gradient(rgba(255, 255, 255, 0.42) 0.7px, transparent 0.7px);
  background-size: 22px 22px;
  -webkit-mask-image: linear-gradient(to bottom right, rgba(0, 0, 0, 0.72), transparent 74%);
  mask-image: linear-gradient(to bottom right, rgba(0, 0, 0, 0.72), transparent 74%);
  pointer-events: none;
}

.story-orbit {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 999px;
  pointer-events: none;
  transition: transform 700ms cubic-bezier(0.2, 0.8, 0.2, 1);
}

.story-orbit::after {
  position: absolute;
  width: 10px;
  height: 10px;
  border: 2px solid rgba(255, 255, 255, 0.86);
  border-radius: 999px;
  background: #46b86d;
  box-shadow: 0 0 0 7px rgba(70, 184, 109, 0.13);
  content: "";
}

.story-orbit--large {
  right: -190px;
  bottom: -164px;
  width: 510px;
  height: 510px;
}

.story-orbit--large::after {
  top: 75px;
  left: 70px;
}

.story-orbit--small {
  top: 156px;
  right: -92px;
  width: 220px;
  height: 220px;
}

.story-orbit--small::after {
  bottom: 28px;
  left: 17px;
  width: 7px;
  height: 7px;
}

.auth-shell--signup .story-orbit--large {
  transform: translate(-16px, -12px) rotate(12deg);
}

.auth-shell--signup .story-orbit--small {
  transform: translate(-12px, 18px) rotate(-10deg);
}

.story-header,
.story-copy,
.story-footer {
  position: relative;
  z-index: 1;
}

.story-header {
  display: flex;
  align-items: center;
}

.brand-lockup {
  display: inline-flex;
  align-items: center;
  gap: 14px;
}

.brand-surface {
  display: inline-flex;
  height: 54px;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  border: 1px solid rgba(255, 255, 255, 0.62);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 12px 28px rgba(4, 28, 18, 0.2);
}

.brand-logo {
  display: block;
  width: auto;
  height: 32px;
  object-fit: contain;
}

.brand-divider {
  width: 1px;
  height: 26px;
  background: rgba(255, 255, 255, 0.28);
}

.brand-caption {
  color: rgba(255, 255, 255, 0.78);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.18em;
}

.story-copy {
  width: min(590px, 100%);
  margin: auto 0;
  padding: 56px 0 48px;
}

.story-kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 20px;
  color: rgba(226, 255, 236, 0.83);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.16em;
}

.story-kicker__dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #64d989;
  box-shadow: 0 0 0 5px rgba(100, 217, 137, 0.12);
}

.story-title {
  display: flex;
  flex-direction: column;
  margin: 0;
  font-size: clamp(38px, 3.6vw, 54px);
  font-weight: 500;
  line-height: 1.14;
  letter-spacing: -0.045em;
}

.story-title strong {
  margin-top: 4px;
  color: #8ce6a8;
  font-weight: 800;
}

.story-description {
  max-width: 540px;
  margin: 24px 0 0;
  color: rgba(235, 247, 239, 0.76);
  font-size: 15px;
  line-height: 1.85;
  word-break: keep-all;
}

.capability-grid {
  display: grid;
  margin-top: 38px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.capability-card {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 13px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.075);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.07);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}

.capability-icon {
  display: flex;
  width: 40px;
  height: 40px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.capability-icon svg {
  width: 20px;
  height: 20px;
}

.capability-card--management .capability-icon {
  color: #baf3ca;
  background: rgba(83, 205, 122, 0.16);
}

.capability-card--market .capability-icon {
  color: #b8f1f5;
  background: rgba(58, 187, 202, 0.16);
}

.capability-label {
  margin: 0;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
}

.capability-description {
  overflow: hidden;
  margin: 4px 0 0;
  color: rgba(237, 247, 240, 0.65);
  font-size: 11px;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.story-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  color: rgba(231, 246, 236, 0.58);
  font-size: 10px;
  letter-spacing: 0.08em;
}

.system-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.system-status__pulse {
  position: relative;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #66dc8d;
}

.system-status__pulse::after {
  position: absolute;
  inset: -4px;
  border: 1px solid rgba(102, 220, 141, 0.45);
  border-radius: inherit;
  content: "";
  animation: statusPulse 2.2s ease-out infinite;
}

.story-footer__copy {
  margin: 0;
  text-align: right;
}

.auth-panel {
  display: flex;
  min-width: 0;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px 64px 34px;
  background: radial-gradient(circle at 100% 0, rgba(36, 139, 75, 0.045), transparent 28%), #ffffff;
  transition: padding 300ms ease;
}

.auth-panel__top {
  display: flex;
  min-height: 32px;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 24px;
}

.mobile-brand-logo {
  display: none;
  width: auto;
  height: 36px;
  object-fit: contain;
}

.access-label {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #7c8a82;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.access-label svg {
  width: 15px;
  height: 15px;
  color: var(--brand-600);
}

.auth-content {
  width: min(460px, 100%);
  margin: auto;
}

.mode-switch {
  display: grid;
  height: 50px;
  padding: 4px;
  grid-template-columns: 1fr 1fr;
  border: 1px solid #e2e9e4;
  border-radius: 14px;
  background: #f4f7f5;
}

.mode-switch button {
  position: relative;
  display: inline-flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 10px;
  outline: none;
  color: #738078;
  background: transparent;
  font-size: 13px;
  font-weight: 700;
  transition: color 220ms ease, background 220ms ease, box-shadow 220ms ease, transform 220ms ease;
}

.mode-switch button:hover {
  color: var(--brand-800);
}

.mode-switch button:focus-visible {
  box-shadow: 0 0 0 3px rgba(36, 139, 75, 0.18);
}

.mode-switch button.is-active {
  color: var(--brand-800);
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(11, 47, 34, 0.08), 0 5px 16px rgba(11, 47, 34, 0.07);
}

.auth-heading {
  margin: 28px 0 24px;
  animation: headingEnter 380ms cubic-bezier(0.2, 0.75, 0.2, 1) both;
}

.auth-eyebrow {
  margin: 0 0 9px !important;
  color: var(--brand-600) !important;
  font-size: 10px !important;
  font-weight: 800;
  letter-spacing: 0.16em;
}

.auth-heading h2 {
  margin: 0;
  color: var(--ink-950);
  font-size: 28px;
  font-weight: 800;
  line-height: 1.28;
  letter-spacing: -0.035em;
  word-break: keep-all;
}

.auth-heading > p:last-child {
  margin: 9px 0 0;
  color: var(--ink-500);
  font-size: 13px;
  line-height: 1.65;
  word-break: keep-all;
}

.form-stage {
  position: relative;
  min-width: 0;
}

.auth-form {
  display: flex;
  flex-direction: column;
  gap: 17px;
  animation: formEnter 430ms cubic-bezier(0.2, 0.78, 0.2, 1) both;
}

.auth-form--signup {
  gap: 13px;
}

.field {
  min-width: 0;
}

.field-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.field-label {
  display: block;
  margin: 0 0 8px;
  color: #304038;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.field-helper {
  margin-bottom: 8px;
  color: #89958e;
  font-size: 10px;
  font-weight: 600;
}

.input-shell {
  position: relative;
  display: flex;
  height: 52px;
  align-items: center;
  border: 1px solid var(--line);
  border-radius: 13px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(10, 42, 29, 0.02);
  transition: border-color 180ms ease, box-shadow 180ms ease, background 180ms ease;
}

.auth-form--signup .input-shell {
  height: 48px;
  border-radius: 12px;
}

.input-shell:hover {
  border-color: #c2d1c8;
}

.input-shell:focus-within {
  border-color: var(--brand-600);
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(36, 139, 75, 0.1), 0 5px 16px rgba(13, 58, 41, 0.05);
}

.input-icon {
  position: absolute;
  left: 15px;
  width: 19px;
  height: 19px;
  color: #96a49c;
  pointer-events: none;
  transition: color 180ms ease;
}

.input-shell:focus-within .input-icon {
  color: var(--brand-600);
}

.input-shell input {
  width: 100%;
  height: 100%;
  min-width: 0;
  padding: 0 14px 0 45px;
  border: 0;
  border-radius: inherit;
  outline: none;
  color: #15241c;
  background: transparent;
  font-size: 13px;
  font-weight: 500;
}

.input-shell--password input {
  padding-right: 50px;
}

.input-shell input::placeholder {
  color: #a7b1ab;
  font-weight: 400;
}

.input-shell input:-webkit-autofill {
  -webkit-text-fill-color: #15241c;
  box-shadow: 0 0 0 1000px #ffffff inset;
  transition: background-color 9999s ease-out;
}

.visibility-button {
  position: absolute;
  right: 8px;
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 9px;
  outline: none;
  color: #87958d;
  background: transparent;
  transition: color 180ms ease, background 180ms ease;
}

.visibility-button:hover {
  color: var(--brand-700);
  background: var(--brand-50);
}

.visibility-button:focus-visible {
  color: var(--brand-700);
  box-shadow: 0 0 0 3px rgba(36, 139, 75, 0.16);
}

.visibility-button svg {
  width: 19px;
  height: 19px;
}

.visibility-button[aria-pressed=true] {
  color: var(--brand-700);
  background: var(--brand-50);
}

.login-options {
  display: flex;
  min-height: 22px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.remember-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #4d5d54;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  user-select: none;
}

.remember-option input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}

.remember-check {
  display: inline-flex;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #c9d5cd;
  border-radius: 5px;
  color: transparent;
  background: #ffffff;
  transition: border-color 160ms ease, color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.remember-check svg {
  width: 13px;
  height: 13px;
}

.remember-option:hover .remember-check {
  border-color: var(--brand-600);
}

.remember-option input:checked + .remember-check {
  border-color: var(--brand-600);
  color: #ffffff;
  background: var(--brand-600);
}

.remember-option input:focus-visible + .remember-check {
  box-shadow: 0 0 0 3px rgba(36, 139, 75, 0.16);
}

.remember-hint {
  color: #97a29c;
  font-size: 10px;
  line-height: 1.4;
  text-align: right;
}

.field-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
}

.form-message {
  display: flex;
  min-height: 42px;
  align-items: flex-start;
  gap: 9px;
  padding: 11px 12px;
  border: 1px solid #fed5d5;
  border-radius: 11px;
  color: #b4232c;
  background: #fff7f7;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.55;
  animation: messageEnter 240ms ease-out both;
}

.form-message svg {
  width: 17px;
  height: 17px;
  flex: 0 0 auto;
  margin-top: 0;
}

.primary-button {
  position: relative;
  display: inline-flex;
  width: 100%;
  height: 52px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  overflow: hidden;
  border: 0;
  border-radius: 13px;
  outline: none;
  color: #ffffff;
  background: linear-gradient(135deg, var(--brand-700), #229c53);
  box-shadow: 0 12px 24px rgba(25, 114, 63, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.16);
  font-size: 13px;
  font-weight: 800;
  letter-spacing: -0.01em;
  transition: transform 180ms ease, box-shadow 180ms ease, filter 180ms ease;
}

.primary-button::before {
  position: absolute;
  top: -80%;
  left: -28%;
  width: 32%;
  height: 260%;
  opacity: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.18), transparent);
  content: "";
  transform: rotate(18deg);
  transition: left 500ms ease, opacity 250ms ease;
}

.primary-button:hover:not(:disabled) {
  box-shadow: 0 15px 28px rgba(25, 114, 63, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.18);
  filter: saturate(1.06);
  transform: translateY(-1px);
}

.primary-button:hover:not(:disabled)::before {
  left: 105%;
  opacity: 1;
}

.primary-button:active:not(:disabled) {
  transform: translateY(0);
}

.primary-button:focus-visible {
  box-shadow: 0 0 0 4px rgba(36, 139, 75, 0.17), 0 12px 24px rgba(25, 114, 63, 0.2);
}

.primary-button:disabled {
  cursor: wait;
  opacity: 0.68;
}

.primary-button svg {
  width: 18px;
  height: 18px;
}

.button-spinner {
  width: 17px;
  height: 17px;
  border: 2px solid rgba(255, 255, 255, 0.38);
  border-top-color: #ffffff;
  border-radius: 999px;
  animation: spin 700ms linear infinite;
}

.form-switch-prompt {
  display: flex;
  min-height: 24px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #7a8780;
  font-size: 12px;
}

.form-switch-prompt button {
  padding: 3px 2px;
  border: 0;
  border-radius: 5px;
  outline: none;
  color: var(--brand-700);
  background: transparent;
  font-size: inherit;
  font-weight: 800;
  text-underline-offset: 3px;
}

.form-switch-prompt button:hover {
  color: var(--brand-800);
  text-decoration: underline;
}

.form-switch-prompt button:focus-visible {
  box-shadow: 0 0 0 3px rgba(36, 139, 75, 0.15);
}

.auth-panel__footer {
  display: flex;
  min-height: 24px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 22px;
  color: #99a49e;
  font-size: 10px;
}

.footer-dot {
  width: 3px;
  height: 3px;
  border-radius: 999px;
  background: #bdc7c1;
}

.auth-shell--signup .auth-panel {
  padding-top: 30px;
  padding-bottom: 24px;
}

.auth-shell--signup .auth-panel__top {
  margin-bottom: 12px;
}

.auth-shell--signup .auth-heading {
  margin-top: 21px;
  margin-bottom: 17px;
}

.auth-shell--signup .auth-heading h2 {
  font-size: 26px;
}

.auth-shell--signup .auth-heading > p:last-child {
  margin-top: 7px;
}

.auth-shell--signup .auth-panel__footer {
  margin-top: 13px;
}

@keyframes formEnter {
  from {
    opacity: 0;
    transform: translate3d(18px, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes headingEnter {
  from {
    opacity: 0;
    transform: translate3d(0, 8px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes messageEnter {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes statusPulse {
  0% {
    opacity: 0.8;
    transform: scale(0.72);
  }
  75%, 100% {
    opacity: 0;
    transform: scale(1.55);
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1160px) {
  .auth-frame {
    grid-template-columns: minmax(0, 0.94fr) minmax(480px, 1.06fr);
  }
  .auth-story {
    padding-right: 38px;
    padding-left: 38px;
  }
  .auth-panel {
    padding-right: 46px;
    padding-left: 46px;
  }
  .capability-grid {
    grid-template-columns: 1fr;
  }
  .capability-card:nth-child(2) {
    display: none;
  }
}
@media (max-width: 920px) {
  .auth-shell {
    align-items: flex-start;
    overflow: auto;
    padding: 20px;
  }
  .auth-frame {
    width: min(760px, 100%);
    min-height: auto;
    grid-template-columns: 1fr;
  }
  .auth-story {
    min-height: 286px;
    padding: 28px 34px 32px;
  }
  .story-copy {
    margin: 34px 0 0;
    padding: 0;
  }
  .story-title {
    font-size: 36px;
  }
  .story-description {
    max-width: 620px;
    margin-top: 15px;
  }
  .capability-grid,
  .story-footer {
    display: none;
  }
  .story-orbit--large {
    right: -145px;
    bottom: -280px;
  }
  .story-orbit--small {
    top: 45px;
  }
  .auth-panel,
  .auth-shell--signup .auth-panel {
    min-height: 590px;
    padding: 30px 48px 34px;
  }
  .auth-shell--signup .auth-panel {
    min-height: 720px;
  }
  .auth-panel__top {
    justify-content: space-between;
    margin-bottom: 18px;
  }
  .mobile-brand-logo {
    display: block;
  }
  .auth-content {
    width: min(500px, 100%);
  }
}
@media (max-width: 600px) {
  .auth-shell {
    padding: 0;
    background: #ffffff;
  }
  .auth-ambient {
    display: none;
  }
  .auth-frame {
    width: 100%;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .auth-story {
    min-height: 214px;
    padding: 23px 22px 28px;
  }
  .brand-surface {
    height: 45px;
    padding: 8px 12px;
    border-radius: 11px;
  }
  .brand-logo {
    height: 27px;
  }
  .brand-divider,
  .brand-caption {
    display: none;
  }
  .story-copy {
    margin-top: 28px;
  }
  .story-kicker {
    margin-bottom: 12px;
    font-size: 9px;
  }
  .story-title {
    display: block;
    font-size: 30px;
    line-height: 1.2;
  }
  .story-title strong {
    margin-left: 5px;
  }
  .story-description {
    display: -webkit-box;
    max-width: 94%;
    overflow: hidden;
    margin-top: 12px;
    font-size: 12px;
    line-height: 1.6;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .story-orbit--small {
    right: -125px;
  }
  .auth-panel,
  .auth-shell--signup .auth-panel {
    min-height: auto;
    padding: 24px 22px 38px;
  }
  .auth-panel__top,
  .auth-shell--signup .auth-panel__top {
    min-height: 0;
    margin-bottom: 22px;
  }
  .mobile-brand-logo {
    display: none;
  }
  .access-label {
    margin-left: auto;
  }
  .auth-heading,
  .auth-shell--signup .auth-heading {
    margin: 23px 0 20px;
  }
  .auth-heading h2,
  .auth-shell--signup .auth-heading h2 {
    font-size: 24px;
  }
  .auth-heading > p:last-child {
    font-size: 12px;
  }
  .field-grid {
    grid-template-columns: 1fr;
    gap: 13px;
  }
  .auth-form,
  .auth-form--signup {
    gap: 15px;
  }
  .auth-form--signup .input-shell {
    height: 50px;
  }
  .form-switch-prompt {
    flex-wrap: wrap;
  }
  .auth-panel__footer,
  .auth-shell--signup .auth-panel__footer {
    flex-wrap: wrap;
    margin-top: 24px;
    text-align: center;
  }
}
@media (max-height: 760px) and (min-width: 921px) {
  .auth-shell {
    align-items: flex-start;
    overflow: auto;
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .auth-frame {
    min-height: 728px;
  }
  .auth-story {
    padding-top: 34px;
    padding-bottom: 32px;
  }
  .story-copy {
    padding-top: 34px;
    padding-bottom: 30px;
  }
  .story-title {
    font-size: 42px;
  }
  .capability-grid {
    margin-top: 25px;
  }
  .auth-panel {
    padding-top: 28px;
    padding-bottom: 22px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .auth-shell *,
  .auth-shell *::before,
  .auth-shell *::after {
    scroll-behavior: auto !important;
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    public mode: AuthMode = 'login';

    public loginForm: any = {
        email: '',
        password: ''
    };

    public signupForm: any = {
        name: '',
        email: '',
        password: '',
        mobile: '',
        office: ''
    };

    public message: string = '';
    public busy: boolean = false;
    public showLoginPassword: boolean = false;
    public showSignupPassword: boolean = false;
    public rememberLogin: boolean = false;
    public iframeCookieBlocked: boolean = false;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();

        const params = new URLSearchParams(location.search);
        const isLogout = params.get('logout') === '1';

        if (isLogout && this.service.auth.status) {
            try {
                await this.service.auth.logout();
            } catch (error) {
                this.message = this.errorMessage(error, '로그아웃을 처리하지 못했습니다.');
            }
        } else if (!isLogout && this.service.auth.status) {
            this.service.href('/dashboard');
            return;
        }

        this.mode = !isLogout && params.get('mode') === 'signup' ? 'signup' : 'login';
        this.updateModeUrl(this.mode);
        await this.service.render();
    }

    public async switchMode(nextMode: AuthMode) {
        if (this.busy || this.mode === nextMode) return;

        this.mode = nextMode;
        this.message = '';
        this.iframeCookieBlocked = false;
        this.showLoginPassword = false;
        this.showSignupPassword = false;
        this.updateModeUrl(nextMode);

        await this.service.render();
        this.focusFirstField(nextMode);
    }

    public async togglePasswordVisibility(target: 'login' | 'signup') {
        if (target === 'login') {
            this.showLoginPassword = !this.showLoginPassword;
        } else {
            this.showSignupPassword = !this.showSignupPassword;
        }

        await this.service.render();
        this.focusField(target === 'login' ? 'login-password' : 'signup-password');
    }

    public async login() {
        if (this.busy) return;

        this.message = '';
        const email = (this.loginForm.email || '').trim();
        const password = this.loginForm.password || '';

        if (!email) {
            this.message = '이메일을 입력해주세요.';
            await this.service.render();
            this.focusField('login-email');
            return;
        }

        if (!password) {
            this.message = '비밀번호를 입력해주세요.';
            await this.service.render();
            this.focusField('login-password');
            return;
        }

        if (!this.isValidEmail(email)) {
            this.message = '올바른 이메일 형식으로 입력해주세요.';
            await this.service.render();
            this.focusField('login-email', true);
            return;
        }

        this.loginForm.email = email;
        this.iframeCookieBlocked = false;
        const storageAccess = this.service.auth.requestIframeStorageAccess();
        this.busy = true;
        await this.service.render();

        try {
            const storageAccessGranted = await storageAccess;
            const response = await wiz.call('login', {
                email,
                password,
                remember: this.rememberLogin
            });
            if (response.code !== 200) {
                throw new Error(
                    response.data?.message || '이메일 또는 비밀번호가 올바르지 않습니다.'
                );
            }

            await this.service.auth.init();
            if (!this.service.auth.status) {
                this.iframeCookieBlocked = this.service.auth.isEmbedded();
                if (this.iframeCookieBlocked) {
                    throw new Error(
                        storageAccessGranted === false
                            ? '브라우저가 iframe 세션 저장을 차단했습니다. 새 탭에서 로그인해주세요.'
                            : 'iframe 로그인 세션을 저장하지 못했습니다. 새 탭에서 로그인해주세요.'
                    );
                }
                throw new Error('로그인 세션을 확인하지 못했습니다.');
            }

            this.loginForm.password = '';
            this.service.href('/dashboard');
        } catch (error) {
            this.busy = false;
            this.message = this.errorMessage(
                error,
                '이메일 또는 비밀번호가 올바르지 않습니다.'
            );
            await this.service.render();
            this.focusField('login-password', true);
        }
    }

    public openStandaloneLogin() {
        if (typeof window === 'undefined') return;
        window.open(
            new URL('/access', window.location.origin).toString(),
            '_blank',
            'noopener,noreferrer'
        );
    }

    public async signup() {
        if (this.busy) return;

        this.message = (
            '신규 계정은 웅빈 운영 담당자의 초대 또는 승인된 SSO를 통해서만 생성할 수 있습니다.'
        );
        await this.service.render();
    }

    private errorMessage(error: any, fallback: string) {
        return error instanceof Error && error.message ? error.message : fallback;
    }

    private isValidEmail(email: string) {
        return CONTACT_EMAIL_PATTERN.test(email);
    }

    private focusFirstField(mode: AuthMode) {
        const targetId = mode === 'signup' ? 'signup-name' : 'login-email';
        this.focusField(targetId);
    }

    private focusField(targetId: string, select: boolean = false) {
        if (typeof document === 'undefined') return;

        window.setTimeout(() => {
            const target = document.getElementById(targetId) as HTMLInputElement | null;
            if (!target) return;
            target.focus();
            if (select) target.select();
        }, 80);
    }

    private updateModeUrl(mode: AuthMode) {
        if (typeof window === 'undefined' || !window.history?.replaceState) return;

        const url = new URL(window.location.href);
        url.searchParams.delete('logout');

        if (mode === 'signup') {
            url.searchParams.set('mode', 'signup');
        } else {
            url.searchParams.delete('mode');
        }

        const nextUrl = url.pathname + url.search + url.hash;
        window.history.replaceState({}, document.title, nextUrl);
    }
}

export default PageAccessComponent;